import ReactStars from "react-rating-stars-component";
import React from "react";

import { ReactComponent as EmptyStar } from "../logo/EmptyStar.svg";
import { ReactComponent as HalfStar } from "../logo/HalfStar.svg";
import { ReactComponent as FullStar } from "../logo/FullStar.svg";

export function FiveStarComponent(props) {
  const { onChange, value, editable, className } = props;
  const activeColor = props.activeColor || "#fed426";
  const size = props.size || 24;
  return (
    <ReactStars
      classNames={className}
      count={5}
      value={value}
      onChange={onChange}
      size={size}
      activeColor={activeColor}
      edit={editable}
      emptyIcon={<EmptyStar width={size} height={size} />}
      halfIcon={<HalfStar width={size} height={size} />}
      filledIcon={<FullStar width={size} height={size} />}
    />
  );
}

export default FiveStarComponent;
